function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo, useRef, useState } from "react";
import Select, { components } from "react-select";
import { twMerge } from "tailwind-merge";
import cc from "classcat";
import Label from "../Label";
import Tooltip from "../Tooltip/Tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import useDarkMode from "../../../hooks/useDarkMode";
import PropTypes from "prop-types";
import InputError from "../Input/InputError";
import Trans from "../../intl/Trans";
import { transliterate } from "transliteration";
import Spinner from "../Spinner";
ReactSelect.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    name: PropTypes.string.isRequired,
    LabelClassName: PropTypes.string,
    helperText: PropTypes.node,
    label: PropTypes.node,
    tooltipContent: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    itemToLabel: PropTypes.func,
    itemToValue: PropTypes.func,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    clearable: PropTypes.bool,
    isLoading: PropTypes.bool,
    onSelectActionItem: PropTypes.func,
    renderActionItem: PropTypes.func,
    renderListItems: PropTypes.func,
    errorMessage: PropTypes.node,
    disabled: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number
    ]),
    placeholder: PropTypes.node,
    noItemsPlaceholder: PropTypes.node,
    data: PropTypes.object,
    onAddCustomItem: PropTypes.func,
    minMenuHeight: PropTypes.number,
    maxMenuHeight: PropTypes.number,
    efacturaCode: PropTypes.string
};
var ACTION_ITEM_INTERNAL_ID = "__ACTION_ITEM_INTERNAL_ID__";
export default function ReactSelect(_param) {
    var items = _param.items, id = _param.id, name = _param.name, LabelClassName = _param.LabelClassName, helperText = _param.helperText, label = _param.label, tooltipContent = _param.tooltipContent, _param_itemToValue = _param.itemToValue, itemToValue = _param_itemToValue === void 0 ? function(item) {
        return item.value;
    } : _param_itemToValue, _param_itemToLabel = _param.itemToLabel, itemToLabel = _param_itemToLabel === void 0 ? function(item) {
        return item.label;
    } : _param_itemToLabel, value = _param.value, onChange = _param.onChange, onBlur = _param.onBlur, clearable = _param.clearable, isLoading = _param.isLoading, onSelectActionItem = _param.onSelectActionItem, renderActionItem = _param.renderActionItem, renderListItems = _param.renderListItems, errorMessage = _param.errorMessage, disabled = _param.disabled, placeholder = _param.placeholder, noItemsPlaceholder = _param.noItemsPlaceholder, onAddCustomItem = _param.onAddCustomItem, _param_minMenuHeight = _param.minMenuHeight, minMenuHeight = _param_minMenuHeight === void 0 ? 200 : _param_minMenuHeight, _param_maxMenuHeight = _param.maxMenuHeight, maxMenuHeight = _param_maxMenuHeight === void 0 ? 300 : _param_maxMenuHeight, efacturaCode = _param.efacturaCode, props = _object_without_properties(_param, [
        "items",
        "id",
        "name",
        "LabelClassName",
        "helperText",
        "label",
        "tooltipContent",
        "itemToValue",
        "itemToLabel",
        "value",
        "onChange",
        "onBlur",
        "clearable",
        "isLoading",
        "onSelectActionItem",
        "renderActionItem",
        "renderListItems",
        "errorMessage",
        "disabled",
        "placeholder",
        "noItemsPlaceholder",
        "onAddCustomItem",
        "minMenuHeight",
        "maxMenuHeight",
        "efacturaCode"
    ]);
    var darkMode = useDarkMode();
    var _useState = _sliced_to_array(useState(""), 2), inputValue = _useState[0], setInputValue = _useState[1];
    var preventAddCustomRef = useRef(null);
    /**
     * Calculate the selected item based on the VALUE of it, received from the parent.
     */ var selectedItem = useMemo(function() {
        if (isLoading) {
            return "";
        }
        var matchedItemToValue = items.find(function(item) {
            var _itemToValue;
            return ((_itemToValue = itemToValue(item)) === null || _itemToValue === void 0 ? void 0 : _itemToValue.toString()) === (value === null || value === void 0 ? void 0 : value.toString());
        });
        if (matchedItemToValue) {
            setInputValue(itemToLabel(matchedItemToValue));
        } else {
            if (onAddCustomItem) {
                setInputValue(value);
            } else {
                setInputValue("");
            }
        }
        return matchedItemToValue || "";
    }, [
        value,
        items,
        isLoading
    ]);
    var internalItems = useMemo(function() {
        if (isLoading) {
            return [];
        }
        return renderActionItem ? _to_consumable_array(items).concat([
            {
                type: ACTION_ITEM_INTERNAL_ID
            }
        ]) : items;
    }, [
        items,
        renderActionItem,
        isLoading
    ]);
    function onSelectItem(selectedItem) {
        /**
         * Make sure that when an item is selected, we don't allow it to be the ACTION ITEM
         * Instead, trigger the custom action item flow
         */ if ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.type) === ACTION_ITEM_INTERNAL_ID) {
            onSelectActionItem && onSelectActionItem();
            return;
        }
        onChange({
            type: "change",
            target: {
                type: "select",
                name: name,
                id: id || name,
                value: selectedItem ? itemToValue(selectedItem) : ""
            }
        });
    }
    var CustomOption = function(_param) {
        var data = _param.data, props = _object_without_properties(_param, [
            "data"
        ]);
        return renderListItems ? /*#__PURE__*/ React.createElement(components.Option, props, data.type === ACTION_ITEM_INTERNAL_ID ? renderActionItem() : renderListItems(data)) : /*#__PURE__*/ React.createElement(components.Option, props, data.type === ACTION_ITEM_INTERNAL_ID ? renderActionItem() : itemToLabel(data));
    };
    var CustomClearIndicator = function(_param) {
        var props = _extends({}, _object_destructuring_empty(_param));
        return /*#__PURE__*/ React.createElement(components.ClearIndicator, _object_spread_props(_object_spread({}, props), {
            className: "!text-gray-400 dark:!text-gray-500 dark:hover:!text-blue-550 dark:focus:!text-blue-550 hover:!text-blue-550 focus:!text-blue-550"
        }));
    };
    var CustomPlaceholder = function(_param) {
        var props = _extends({}, _object_destructuring_empty(_param));
        return placeholder ? /*#__PURE__*/ React.createElement(components.Placeholder, props, placeholder) : null;
    };
    var CustomNoOptionMessage = function(_param) {
        var props = _extends({}, _object_destructuring_empty(_param));
        return renderActionItem ? null : /*#__PURE__*/ React.createElement("div", {
            className: twMerge(cc([
                "select-none px-3 py-2 text-center dark:bg-blue-775 text-gray-400 shadow-sm hover:cursor-not-allowed dark:text-gray-500"
            ]))
        }, /*#__PURE__*/ React.createElement(components.NoOptionsMessage, props, noItemsPlaceholder && /*#__PURE__*/ React.createElement("span", null, noItemsPlaceholder), !noItemsPlaceholder && /*#__PURE__*/ React.createElement(Trans, null, "common.dropdown.no-items")));
    };
    var CustomLoadingIndicator = function() {
        return /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center mr-1.5"
        }, /*#__PURE__*/ React.createElement(Spinner, {
            className: "w-5 h-5"
        }));
    };
    var customStyles = {
        control: function(styles, state) {
            return _object_spread_props(_object_spread({}, styles), {
                padding: "2px 0px",
                boxShadow: errorMessage ? "none" : state.isFocused ? "0 0 0 1px #2684FF" : "none",
                borderColor: errorMessage ? state.isFocused ? "#FCA5A5" : "#EF4444" : darkMode ? "#46476C" : "#E5E7EB",
                backgroundColor: darkMode ? "#2a2c4c" : "#F9FAFB",
                borderRadius: "0.375rem",
                pointerEvents: "auto",
                "&:hover": {
                    cursor: disabled ? "not-allowed" : "pointer",
                    transitionDuration: "150ms"
                }
            });
        },
        menuList: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                padding: 0,
                backgroundColor: darkMode ? "#2a2c4c" : "#F9FAFB"
            });
        },
        option: function(styles, state) {
            return _object_spread_props(_object_spread({}, styles), {
                borderBottom: "1px solid",
                borderColor: darkMode ? "#46476C" : "#E5E7EB",
                backgroundColor: state.isFocused ? darkMode ? state.isSelected ? "#1013a1" : "#1D4ED8" : "#E5EAFE" : darkMode ? "#2a2c4c" : "transparent",
                color: state.isSelected ? darkMode ? "#60A5FA" : "#3B82F6" : darkMode ? "#E5E7EB" : "#141C35",
                "&:last-child": {
                    borderStyle: "none"
                },
                "&:hover": {
                    backgroundColor: darkMode ? state.isSelected ? "#1013a1" : "#1D4ED8" : "#E5EAFE",
                    cursor: "pointer",
                    transitionDuration: "150ms"
                }
            });
        },
        input: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                border: "none",
                visibility: "visible",
                wordBreak: "break-all",
                color: disabled ? darkMode ? "#6B7280" : "#9CA3AF" : darkMode ? "#E5E7EB" : "#141C35",
                input: {
                    opacity: "1 !important"
                },
                "input:focus": {
                    boxShadow: "none"
                }
            });
        },
        dropdownIndicator: function(styles, state) {
            var menuIsOpen = state.selectProps.menuIsOpen;
            return _object_spread_props(_object_spread({}, styles), {
                display: isLoading ? "none" : "flex",
                transform: menuIsOpen ? "rotate(180deg)" : "",
                transitionProperty: "all",
                transitionDuration: "150ms",
                color: disabled ? darkMode ? "#6B7280" : "#9CA3AF" : darkMode ? "#E5E7EB" : "#141C35",
                "&:hover": {
                    color: disabled ? darkMode ? "#6B7280" : "#9CA3AF" : darkMode ? "#E5E7EB" : "#141C35",
                    cursor: disabled ? "not-allowed" : "pointer"
                }
            });
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "relative flex w-full flex-col",
            {
                "gap-y-1": label
            }
        ]))
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center gap-x-2"
    }, label && /*#__PURE__*/ React.createElement(Label, {
        className: twMerge(cc([
            "line-clamp-1 break-all text-sm dark:text-gray-200",
            {
                "p-1": !tooltipContent
            },
            LabelClassName
        ])),
        htmlFor: name
    }, label), tooltipContent && /*#__PURE__*/ React.createElement(Tooltip, {
        content: tooltipContent
    }, /*#__PURE__*/ React.createElement("div", {
        className: "py-1"
    }, /*#__PURE__*/ React.createElement(InformationCircleIcon, {
        className: "h-5 w-5 stroke-black dark:stroke-gray-200"
    })))), /*#__PURE__*/ React.createElement(Select, _object_spread({
        styles: customStyles,
        value: selectedItem,
        name: name,
        isClearable: clearable,
        options: internalItems,
        onChange: onSelectItem,
        menuPlacement: "auto",
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        onFocus: function(e) {
            return e.target.select();
        },
        onBlur: function(event) {
            var // We need this because in modals the keyboard navigation doesn't work. Even though the
            // next element appears to be correct, the focus seems to go to radix dialog, so we force
            // the focus on the correct input
            _event_relatedTarget;
            (_event_relatedTarget = event.relatedTarget) === null || _event_relatedTarget === void 0 ? void 0 : _event_relatedTarget.focus();
            if (onBlur) {
                onBlur(event);
            }
        },
        components: {
            ClearIndicator: CustomClearIndicator,
            Option: CustomOption,
            IndicatorSeparator: function() {
                return null;
            },
            Placeholder: CustomPlaceholder,
            NoOptionsMessage: CustomNoOptionMessage,
            SingleValue: function() {
                return null;
            },
            LoadingIndicator: CustomLoadingIndicator
        },
        getOptionLabel: itemToLabel,
        getOptionValue: itemToValue,
        isLoading: isLoading,
        isDisabled: disabled || isLoading,
        backspaceRemovesValue: false,
        filterOption: function(item, inputValue) {
            var _item_label;
            if (inputValue === itemToLabel(selectedItem)) {
                return true;
            }
            if (transliterate((_item_label = item.label) === null || _item_label === void 0 ? void 0 : _item_label.toLowerCase()).includes(transliterate(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase()))) {
                return true;
            }
            if (item.data.type === ACTION_ITEM_INTERNAL_ID) {
                return true;
            }
        },
        onInputChange: function(selectInputValue, action) {
            if (action.action === "input-change") {
                setInputValue(selectInputValue);
            }
            // If we have onAddCustomItem and we select a value from the items list,
            // we don't want onAddCustomItem to run
            // TODO -> Try to find another solution
            if (onAddCustomItem) {
                if (action.action === "set-value") {
                    preventAddCustomRef.current = true;
                }
                // Reset prevent custom item on input change
                if (action.action === "input-change") {
                    preventAddCustomRef.current = false;
                }
            }
            if (action.action === "input-blur") {
                if (onAddCustomItem && !preventAddCustomRef.current) {
                    onAddCustomItem(inputValue);
                } else {
                    if (selectedItem) {
                        setInputValue(itemToLabel(selectedItem));
                    } else {
                        setInputValue("");
                    }
                }
            }
        },
        inputValue: inputValue
    }, props)), !errorMessage && !!efacturaCode && /*#__PURE__*/ React.createElement("span", {
        className: "text-xs dark:text-gray-300 text-gray-500 pt-1.5"
    }, efacturaCode, helperText && " - ", helperText && /*#__PURE__*/ React.createElement("span", {
        className: "text-gray-400"
    }, helperText)), helperText && !errorMessage && !efacturaCode && /*#__PURE__*/ React.createElement("div", {
        className: cc([
            "pt-1.5 text-xs text-gray-400"
        ])
    }, helperText), errorMessage && /*#__PURE__*/ React.createElement(InputError, {
        className: cc([
            "pt-1.5"
        ])
    }, errorMessage));
}
